import { HEADER_POSITION_TYPE } from '@/scripts/constants/header'
import {
  HIDE_ACCOUNT_BULLET,
  RESET_KEYBOARD_NAVIGATION,
  RESET_MENU_ID,
  SET_HEADER_FIXED_POSITION,
  SET_HEADER_STATIC_POSITION,
  SET_KEYBOARD_NAVIGATION,
  SHOW_ACCOUNT_BULLET,
  UPDATE_BACKGROUND,
  UPDATE_MENU_ID,
  UPDATE_HEADER_IS_COLLAPSED,
} from './mutations'

export const ACTION_UPDATE_BACKGROUND = 'ACTION_UPDATE_BACKGROUND'
export const ACTION_UPDATE_MENU_ID = 'ACTION_UPDATE_MENU_ID'
export const ACTION_RESET_MENU_ID = 'ACTION_RESET_MENU_ID'
export const ACTION_SET_HEADER_STATIC_POSITION = 'ACTION_SET_HEADER_STATIC_POSITION'
export const ACTION_SET_HEADER_FIXED_POSITION = 'ACTION_SET_HEADER_FIXED_POSITION'
export const ACTION_UPDATE_KEYBOARD_NAVIGATION = 'ACTION_UPDATE_KEYBOARD_NAVIGATION'
export const ACTION_RESET_KEYBOARD_NAVIGATION = 'ACTION_RESET_KEYBOARD_NAVIGATION'
export const ACTION_SHOW_ACCOUNT_BULLET = 'ACTION_SHOW_ACCOUNT_BULLET'
export const ACTION_HIDE_ACCOUNT_BULLET = 'ACTION_HIDE_ACCOUNT_BULLET'
export const ACTION_UPDATE_HEADER_IS_COLLAPSED = 'ACTION_UPDATE_HEADER_IS_COLLAPSED'
export const ACTION_ADJUST_HEADER_PADDING = 'ACTION_ADJUST_HEADER_PADDING'
export const actions = {
  [ACTION_UPDATE_BACKGROUND]: function ({ commit }, payload) {
    commit(UPDATE_BACKGROUND, payload)
  },
  [ACTION_UPDATE_MENU_ID]: function ({ commit }, payload) {
    commit(UPDATE_MENU_ID, payload)
  },
  [ACTION_RESET_MENU_ID]: function ({ commit }) {
    commit(RESET_MENU_ID)
  },
  [ACTION_SET_HEADER_STATIC_POSITION]: function ({ commit }) {
    commit(SET_HEADER_STATIC_POSITION)
  },
  [ACTION_SET_HEADER_FIXED_POSITION]: function ({ commit }, payload) {
    commit(SET_HEADER_FIXED_POSITION, payload)
  },
  [ACTION_UPDATE_KEYBOARD_NAVIGATION]: function ({ commit }, payload) {
    commit(SET_KEYBOARD_NAVIGATION, payload)
  },
  [ACTION_RESET_KEYBOARD_NAVIGATION]: function ({ commit }) {
    commit(RESET_KEYBOARD_NAVIGATION)
  },
  [ACTION_SHOW_ACCOUNT_BULLET]: function ({ commit }) {
    commit(SHOW_ACCOUNT_BULLET)
  },
  [ACTION_HIDE_ACCOUNT_BULLET]: function ({ commit }) {
    commit(HIDE_ACCOUNT_BULLET)
  },
  [ACTION_UPDATE_HEADER_IS_COLLAPSED]: function ({ commit }, payload) {
    commit(UPDATE_HEADER_IS_COLLAPSED, payload)
  },
  [ACTION_ADJUST_HEADER_PADDING]: function ({ state }) {
    if (state.position.type === HEADER_POSITION_TYPE.FIXED && state.position.height) {
      document.body.style.paddingTop = `${state.position.height}px`
    }
  },
}
